import { render, staticRenderFns } from "./AdressManage.vue?vue&type=template&id=3709079d&scoped=true"
import script from "./AdressManage.vue?vue&type=script&lang=js"
export * from "./AdressManage.vue?vue&type=script&lang=js"
import style0 from "./AdressManage.vue?vue&type=style&index=0&id=3709079d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709079d",
  null
  
)

export default component.exports